import React, { useEffect, useState } from 'react';
export const StarryBackground = () => {
  const [stars, setStars] = useState<{
    id: number;
    x: number;
    y: number;
    size: number;
    delay: number;
    duration: number;
  }[]>([]);
  useEffect(() => {
    // Generate random stars
    const newStars = Array.from({
      length: 150
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2 + 0.5,
      delay: Math.random() * 5,
      duration: Math.random() * 3 + 2
    }));
    setStars(newStars);
  }, []);
  return <div className="fixed inset-0 z-[-1] overflow-hidden pointer-events-none bg-mystic-bg" data-id="element-233">
      {stars.map(star => <div key={star.id} className="absolute rounded-full bg-moon animate-twinkle" style={{
      left: `${star.x}%`,
      top: `${star.y}%`,
      width: `${star.size}px`,
      height: `${star.size}px`,
      animationDelay: `${star.delay}s`,
      animationDuration: `${star.duration}s`
    }} data-id="element-234" />)}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-mystic-bg/50 to-mystic-bg pointer-events-none" data-id="element-235" />
    </div>;
};